<template>
    <div>
        <label class="block text-gray-900 dark:text-gray-300 text-sm font-medium leading-6">
            {{ $t('organisations.form.general.auth_code') }} *
        </label>
        <div class="flex items-center">
            <BaseInput
                id="authCodeFirstRef"
                v-model="authCodeFirst"
                :label="$t('organisations.form.general.auth_code') + '1'"
                label-classes="hidden"
                :rules="{ min: 4, max: 4, required: true }"
                error-classes="hidden"
                @input="checkAuthCodeFirst"
                @keyup="checkAuthCodeFirst" />
            <div class="mx-1">
                -
            </div>
            <BaseInput
                id="authCodeSecondRef"
                v-model="authCodeSecond"
                :label="$t('organisations.form.general.auth_code') + '2'"
                label-classes="hidden"
                :rules="{ min: 4, max: 4, required: true }"
                error-classes="hidden"
                @input="checkAuthCodeSecond"
                @keyup="checkAuthCodeSecond" />
            <div class="mx-1">
                -
            </div>
            <BaseInput
                id="authCodeThirdRef"
                v-model="authCodeThird"
                :label="$t('organisations.form.general.auth_code') + '3'"
                label-classes="hidden"
                :rules="{ min: 4, max: 4, required: true }"
                error-classes="hidden"
                @input="checkAuthCodeThird"
                @keyup="checkAuthCodeThird" />
        </div>
    </div>
</template>

<script setup>
import {useI18n} from "vue-i18n"

const {t: $t} = useI18n()

defineProps({
    modelValue: {
        type: String,
        required: true
    }
})

const emits = defineEmits(['update:modelValue'])

const authCodeFirst = ref('')
const authCodeSecond = ref('')
const authCodeThird = ref('')

const authCode = computed(() => {
    return authCodeFirst.value + '-' + authCodeSecond.value + '-' + authCodeThird.value
})

watchEffect(() => {
    emits('update:modelValue', authCode.value)
})

function checkAuthCodeFirst() {
    if (authCodeFirst.value.search('-') >= 0) {
        authCodeFirst.value = authCodeFirst.value.replaceAll('-', '')
    }

    if (authCodeFirst.value.length === 4) {
        document.getElementById('authCodeSecondRef').querySelector('input').focus()
    }

    checkAuthCode()
}

function checkAuthCodeSecond() {
    if (authCodeSecond.value.search('-') >= 0) {
        authCodeSecond.value = authCodeSecond.value.replaceAll('-', '')
    }

    if (authCodeSecond.value.length === 4) {
        document.getElementById('authCodeThirdRef').querySelector('input').focus()
    }

    checkAuthCode()
}

function checkAuthCodeThird() {
    if (authCodeThird.value.search('-') >= 0) {
        authCodeThird.value = authCodeThird.value.replaceAll('-', '')
    }

    if (authCodeThird.value.length > 4) {
        authCodeThird.value = authCodeThird.value.slice(0, 4)
    }

    checkAuthCode()
}

function checkAuthCode() {
    if (authCodeFirst.value.length > 4) {
        const authCodeSpliced = authCodeFirst.value
        authCodeFirst.value = authCodeSpliced.slice(0, 4)
        authCodeSecond.value = authCodeSpliced.slice(4)
    }

    if (authCodeSecond.value.length > 4) {
        const authCodeSpliced = authCodeSecond.value
        authCodeSecond.value = authCodeSpliced.slice(0, 4)
        authCodeThird.value = authCodeSpliced.slice(4)
    }
}
</script>
